// extracted by mini-css-extract-plugin
module.exports = {"container":"DZIViewerContainer_container__3W619"};